import { HassConfig } from "home-assistant-js-websocket";

export function DummyComponentReturn(props: Partial<HassConfig>) {
  return props;
}
